import React from "react";
import { TrashIcon } from "lucide-react";
import axios from "axios";
import ResponseContent from "./ResponseContent";

const Message = ({
  message,
  token,
  API_URL,
  threadId,
  onDelete,
  expandedMessages,
  setExpandedMessages,
  handleError,
  streamingMessageId,
  onStreamComplete,
}) => {
  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const date = new Date(timestamp);
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return `${diffInSeconds}s ago`;
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    if (diffInSeconds < 604800)
      return `${Math.floor(diffInSeconds / 86400)}d ago`;

    return date.toLocaleDateString();
  };

  const formatDuration = (duration) => {
    if (!duration || isNaN(duration)) return "0.00s";
    // 如果输入是毫秒，转换为秒
    const inSeconds = duration / 1000;
    return `${inSeconds.toFixed(2)}s`;
  };

  const handleDeleteMessage = async () => {
    if (!window.confirm("Are you sure you want to delete this message?")) {
      return;
    }

    try {
      await axios.delete(
        `${API_URL}/api/threads/${threadId}/messages/${message._id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onDelete(message._id);
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <div className="p-6 bg-gray-800 rounded-lg border border-gray-700 shadow-lg hover:shadow-xl transition-shadow relative group">
      <div className="space-y-4">
        <div className="flex justify-between items-center border-b border-gray-700 pb-2">
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-400">
              {formatTimestamp(message.createdAt)}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs px-2 py-1 bg-gray-700 rounded-full text-gray-300">
              {message.processingStatus}
            </span>
            <button
              onClick={handleDeleteMessage}
              className="text-gray-500 hover:text-red-500 transition-colors p-1 rounded hover:bg-gray-700"
              title="Delete message"
            >
              <TrashIcon size={16} />
            </button>
          </div>
        </div>

        <div className="bg-gray-700/50 p-4 rounded-lg">
          <p className="text-blue-300 font-medium mb-1">Question:</p>
          <p className="text-gray-100">{message.text}</p>
        </div>

        {message.llmResponse && (
          <div className="bg-gray-700/30 p-4 rounded-lg">
            <p className="text-green-400 font-medium mb-1">Response:</p>
            <div className="text-gray-100 whitespace-pre-wrap">
              {message.llmResponse.response}
              {message._id === streamingMessageId && (
                <span className="inline-block h-4 w-2 ml-1 bg-blue-500 animate-pulse" />
              )}
            </div>

            <div className="mt-4 pt-3 border-t border-gray-600">
              <div className="flex flex-wrap gap-4 text-xs">
                <span className="bg-gray-700 px-2 py-1 rounded text-blue-300">
                  Model: {message.llmResponse?.model || "Processing..."}
                </span>
                {message._id !== streamingMessageId && message.llmResponse && (
                  <>
                    <span className="bg-gray-700 px-2 py-1 rounded text-green-300">
                      Total Time:{" "}
                      {formatDuration(message.llmResponse.totalDuration)}
                    </span>
                    {/* FIXME! 这里后端没有返回总的计数，mongodb里面也没有 */}
                    {/* <span className="bg-gray-700 px-2 py-1 rounded text-green-300">
                      Eval Time:{" "}
                      {formatDuration(message.llmResponse.evalDuration)}
                    </span>

                    <span className="bg-gray-700 px-2 py-1 rounded text-green-300">
                      Prompt Token: {message.llmResponse.promptEvalCount}
                    </span>

                    <span className="bg-gray-700 px-2 py-1 rounded text-green-300">
                      Eval Token: {message.llmResponse.evalCount}
                    </span> */}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {message.errorDetails && (
          <div className="bg-red-900/30 p-4 rounded-lg border border-red-800/50">
            <p className="text-red-400 font-medium mb-1">Error:</p>
            <p className="text-red-200">{message.errorDetails.message}</p>
            <p className="text-xs text-red-400 mt-2">
              Error Code: {message.errorDetails.code}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Message;
